export function validateStringLength (value, maxLength, message) {
  if (!value) {
    return true
  }

  if (value.length > maxLength) {
    return message
  }

  return true
}
